import { defineMessages, useIntl } from 'react-intl';

import { Button } from '@packages/shared/src/ui/Button/Button';

import type { LinearSuggestionsItemProps } from './LinearSuggestions.Item';
import { LinearSuggestionsItem } from './LinearSuggestions.Item';

const messages = defineMessages({
  adoptAriaLabel: {
    id: 'searchbar.suggestion.adopt.aria-label',
    defaultMessage: 'in Suche übernehmen',
  },
});

export type LinearSuggestionsAdoptableItemProps = LinearSuggestionsItemProps & {
  /** Callback fired when the user clicks the arrow to the right of the item, arrow is only shown if a callback exists */
  onAdopt?: () => void;
  className?: string;
  leftIcon?: React.ReactNode;
};

export const LinearSuggestionsAdoptableItem = ({
  onAdopt,
  children,
  leftIcon,
  className,
}: LinearSuggestionsAdoptableItemProps) => {
  const { formatMessage } = useIntl();

  return (
    <LinearSuggestionsItem className={`${leftIcon ? 'pl-0' : ''} ${className || ''}`}>
      {leftIcon && (
        <div
          className="w-12" // corresponds to theme spacing 6, which is the default left padding of the items
        >
          {leftIcon}
        </div>
      )}
      {children}
      <Button
        className="text-color-grey-dark rounded-full"
        variant="icon-flat"
        disabled={!onAdopt}
        aria-label={formatMessage(messages.adoptAriaLabel)}
        onClick={(e) => {
          e.stopPropagation();
          e.preventDefault();
          onAdopt?.();
        }}
        onKeyDown={(event) => {
          if (event.key === 'Enter') {
            event.preventDefault();
            event.stopPropagation();
            onAdopt?.();
          }
        }}
      >
        <span className="icon-emp-adoptarrow size-4" />
      </Button>
    </LinearSuggestionsItem>
  );
};
